import { useState, useEffect, useRef } from 'react';

interface GenerationTimerProps {
  startTime?: number;
  isGenerating?: boolean;
  showTotal?: boolean; // Show total time after generation completes
}

export default function GenerationTimer({ 
  startTime, 
  isGenerating, 
  showTotal = false 
}: GenerationTimerProps) {
  const [elapsedTime, setElapsedTime] = useState(0);
  const [finalTime, setFinalTime] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (startTime && isGenerating) {
      // Start timer during generation
      timerRef.current = setInterval(() => {
        const elapsed = (Date.now() - startTime) / 1000;
        setElapsedTime(elapsed);
        setFinalTime(elapsed); // Keep updating final time
      }, 100);
      
      return () => {
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
      };
    } else if (!isGenerating && timerRef.current) {
      // Generation finished, clear timer but keep final time
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, [startTime, isGenerating]);

  if (!startTime) return null;

  const timeToShow = isGenerating ? elapsedTime : finalTime;
  
  if (!isGenerating && !showTotal) return null;

  return (
    <div className="flex items-start justify-start mt-2">
      <span className="text-xs text-gray-900 dark:text-gray-100 font-mono">
        {timeToShow.toFixed(1)}s
      </span>
    </div>
  );
}